import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  ion-content {
    --background: url('/assets/layout-own-ai-man/tattoed-guy-picture.png')
      no-repeat center center / cover;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url('/assets/layout-own-ai-man/overlay-gradient.png')
        no-repeat center center / cover;
      z-index: 1;
      pointer-events: none;
    }

    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      height: 100%;
      padding-bottom: 24px;
      position: relative;
      z-index: 2;
    }

    .app-logo {
      margin: 0 0 20px;
    }

    .loading-wrapper {
      margin-top: 32px;
      width: 90%;
    }
  }

  #root .ion-page & {
    ion-footer {
      padding: 16px 16px 32px;

      .page-footer-button {
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        border-radius: 12px;
      }
    }
  }
`;

export const PageTitleStyles = styled(UiTypography)`
  .ion-page & {
    margin: 0;
    font-weight: 600;
  }
`;

export const PageSubtitleStyles = styled(UiTypography)`
  .ion-page & {
    color: transparent;
    background: linear-gradient(136deg, #7f36f3 -3.67%, #ed0d80 106.36%);
    background-clip: text;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: auto;
  position: relative;
  z-index: 2;
`;
